<div class="frame-in">
    <div class="letters stories" [class.hidden]="loading()">
        <button type="button" class="leave-button" (click)="previousState()"></button>

        <button type="button" class="slider-back" (click)="previous()"></button>
        <button type="button" class="slider-next" (click)="next()"></button>

        <div>
            @for (tab of tabs(); track $index; let i = $index) {
            @if (activeWindow() === i + 1) {
            <div class="blocks-list" style="padding-top: 25px">
                @for (item of tab; track item.orderNumber || $index; let index = $index) {
                <div class="item" [class.lock]="item.lock" [routerLink]="item.url">
                    <div class="number">{{ (i * 6 + index) + 1 }}</div>

                    @if (item.poster) {
                    <img [src]="item.poster">
                    } @else {
                    <img src="assets/images/new-letters/example-picture.jpg">
                    }

                    <div class="description-box-menu">
                        Lesson {{ item.orderNumber }} - {{ item.countryTitle }}
                    </div>
                </div>
                }
            </div>
            }
            }
        </div>
        <img class="frame-bg" src="assets/images/stories/bg-Stories.png">
    </div>
</div>

<div class="pagination" [style.left.px]="-styleLeftPx()">
    <div class="wrap">
        @for (tab of tabs(); track $index; let index = $index) {
        <span (click)="activeWindow.set(index + 1)" [class.active]="(index + 1) === activeWindow()">
            {{ index + 1 }}
        </span>
        }
    </div>
</div>
